/*eslint-disable @typescript-eslint/ban-types*/
/*eslint-disable @typescript-eslint/no-unused-vars*/
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import './WaitNode.css';
import { ExecutionPlan } from './ExecutionPlan';
import { Box, IconButton, Paper, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check'
import { Handle, Position } from '@xyflow/react';
import { IconWithTooltip } from '../../../globalUtils/globalIcons';
import { CustomInput } from '../../../globalUtils/globalExports';
import { Id, toast } from 'react-toastify';
import { cloneDeep } from 'lodash';


interface WaitNodeProps {
    data: {
        executionPlan: ExecutionPlan,
        handleUpdateExecutionPlan: Function;
        removeNode: Function;
        nodeId: string;
        ifOrElse: string;
        parentNodeId: string;
        actionParentNodeId: string;
    }
}

const WaitNode: React.FC<WaitNodeProps> = (props) => {
    const {executionPlan,handleUpdateExecutionPlan,nodeId,parentNodeId, ifOrElse, actionParentNodeId, removeNode} = props.data;
    const [waitTime,setWaitTime] = useState<number | null> (null);
    const waitTimeRef = useRef<number | null>(null);

    const actionIdx = useMemo(()=>executionPlan?.actions?.findIndex((executionDataItem) => executionDataItem.flowType === ifOrElse && executionDataItem?.parentNodeId === actionParentNodeId),[executionPlan]);
    const waitItemIndex = useMemo(()=>executionPlan?.actions?.[actionIdx]?.waitList?.findIndex(item => item?.waitNodeId === nodeId),[executionPlan,actionIdx]); 

    const errorMessage = (msg: string):Id => toast.error(msg);

    const handleWaitTimeValueChange = useCallback((value) => {
        if(!value) {
            setWaitTime(null);
            return;
        }
        if(isNaN(Number(value)) || value < 0 ) {
            errorMessage('Waiting time must be a positive number.');
            return;
        }

        const stringValue = String(value);
        const parts = stringValue.split('.');

        if (parts[0].length > 3) {
            toast.warn('Wait time cannot exceed 3 digits');
            return;
        }

        if (parts.length > 1 && parts[1].length > 1) {
            toast.warn('Wait time can only have one decimal place');
            return;
        }
        setWaitTime(value);
        waitTimeRef.current = value;
        const formattedData = {
            waitTime: value,
            waitParentNodeId: parentNodeId,
            waitNodeId: nodeId
        }
        const executionData = cloneDeep(executionPlan);
        if(waitItemIndex === -1){
            executionData?.actions?.[actionIdx]?.waitList?.push(formattedData)
        }else{
            executionData.actions[actionIdx].waitList[waitItemIndex] = formattedData
        }
        handleUpdateExecutionPlan(executionData);
    },[actionIdx,waitItemIndex,executionPlan]);

    useEffect(()=>{
        if(executionPlan) {
            const waitActionItem = executionPlan?.actions?.find((executionDataItem) => executionDataItem.flowType === ifOrElse && executionDataItem?.parentNodeId === actionParentNodeId)?.waitList?.find(item => item?.waitNodeId === nodeId);
            if(waitActionItem){
                setWaitTime(waitActionItem?.waitTime);
            }
        }
    },[executionPlan])

    
    return (
        <div className='advance__rule__engine__wait__block' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <Paper
            elevation={3}
            sx={{
                border: '1px solid #DC6A00',
                borderLeft: '6px solid #DC6A00',
                borderRadius: '8px',
                padding: '8px 16px',
                minWidth: '280px !important',
                backgroundColor: '#fff',
                position: 'relative',
                marginBottom: '16px',
                minHeight: '110px'
            }}
            >
                <IconButton
            size="small"
            onClick={() => {
                if(removeNode) removeNode(nodeId, 'wait', actionParentNodeId, ifOrElse);
            }}
            sx={{ position: 'absolute', top: 0, right: 0 }}
          >
            <CloseIcon fontSize="small" sx={{ color: '#666' }} />
          </IconButton>
                <Handle type="target" className='transparent-handle' position={Position.Top} />
                <Handle type="source" position={Position.Bottom} className='transparent-handle'/>

                {/* Wait Node Title */}
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    marginBottom="8px"
                >
                   <Box display="flex" alignItems="center" gap={'5px'}>
                        <IconWithTooltip iconClassName={'wait-node-sidebar-1'} />
                        <Typography
                            variant="subtitle1"
                            sx={{
                            fontWeight: 450,
                            fontSize: '0.9rem',
                            marginBottom: '1px'
                            }}
                        >
                            {'Wait'}
                        </Typography>
                    </Box>
                </Box>


                {/* Wait Node content */}
                <Box
                    sx={{
                        backgroundColor: '#ffe5d2',
                        padding: '8px',
                        borderRadius: '10px',
                        position: 'relative',
                        minHeight: '30px',
                        display: 'flex'
                    }}
                >
                    <div 
                        style = {{
                            display:'flex',
                            justifyContent: 'space-between',
                            flexDirection: 'row',
                            width: '100%'
                        }}
                    >

                        <div className='wait__block__content'>
                            <div className='wait__block__content-label'>
                                <span
                                    style={{
                                        width: '8px',
                                        height: '8px',
                                        backgroundColor: '#DC6A00',
                                        borderRadius: '50%',
                                        display: 'inline-block',
                                    }}
                                />
                                <span>
                                    Wait for
                                </span>
                            </div>
                            <div className='wait__block__content-label'>
                                <CustomInput 
                                    inputValue={waitTime??''} 
                                    inputFieldId={'advance__rule__engine__wait__block__wait-time-input'} 
                                    isRequired={false} 
                                    inputType={'number'}
                                    handleInputChange={
                                        (event)=>{
                                            handleWaitTimeValueChange(event?.target?.value);
                                        }
                                    }
                                /> 
                            </div>
                            <div className='wait__block__content-label'>
                                <span>Minutes.</span>
                            </div>
                        </div>



                    </div> 
                </Box>
            </Paper>
        </div>
    )
}

export default WaitNode;